<ef-process-detail [process]="process$ | async"></ef-process-detail>
<ef-loading processingText="Importing..." [processing]="IsLoading"></ef-loading>
<ef-import-presenter
    [message]="message"
    [messages]="messages"
    [includeInactive]="includeInactive$ | async"
    (StartImport)="onStartImport($event)"
    (SetIncludeInactive)="onSetIncludeInactive($event)"
></ef-import-presenter>
